<script lang="ts">

	import Router from 'svelte-spa-router';
	import EditorMain from './components/editor/EditorMain.svelte';
	import Main from './components/main/Main.svelte';
import StandaloneComponent from './components/main/StandaloneComponent.svelte';


	const routes = {
		'/Main': Main,
		'/Editor': EditorMain,
		'/Standalone': StandaloneComponent,
	};
</script>

<Router {routes} />

<style>

</style>
